
import React, { useEffect, useState } from "react";

import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import attendeAvatar from "assets/images/common/others/attendeAvatar.png";

import { useNavigate } from "react-router-dom";

import { siteRoutes } from "utils/helpers/enums/routes.enum";

import useUtils from "hooks/useUtils";
import useUsers from "containers/user-management/useHooks";
import ExperienceDetail from "./component/ExperienceDetail";
import AmbassadorCommunity from "./component/AmbassadorCommunity";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";



interface Tab {
  name: string;
  Component: JSX.Element;
}

const AmbassadorExperiencesView = () => {
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { getAmbassadorExperienceById } = useUsers();

  const tabs: Tab[] = [
    { name: "Overview", Component: <ExperienceDetail eventData={data} /> },
    { name: "Community", Component: <AmbassadorCommunity eventId={data?.id} /> },
  ];

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  useEffect(() => {
    if (params?.id) {
      getAmbassadorExperienceById(params.id, setData);
    }
  }, [params?.id]);

  const goToBack = () => {
    navigate(-1);
  };

  const goToParticipantsView = (id: number) => {
    navigate(`${siteRoutes.viewAmbassadorExperiencesParticipants}?id=${id}`);
  };

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {data?.name || "Ambassador Experience"}
      </h1>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex gap-4 items-center flex-wrap">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {data?.name || ""}
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md px-2 py-1">
            Ambassador Experience
          </p>
        </div>
        <div className="flex items-center gap-4 my-3 flex-wrap">
          {data?.subscriptions && data.subscriptions.length > 0 && (
            <>
              <div className="flex -space-x-2">
                {data.subscriptions.slice(0, 3).map((sub: any, index: number) => (
                  <img
                    key={index}
                    src={
                      sub?.user?.profilePicId
                        ? concatPathWithBackendUrl(sub.user.profilePicId)
                        : attendeAvatar
                    }
                    alt={sub?.user?.firstName ? `${sub.user.firstName} ${sub.user.lastName}` : "Participant"}
                    className="w-8 h-8 rounded-full border-1 border-white object-cover"
                  />
                ))}
              </div>
              <span className="text-base font-semibold text-warmGray">
                {data.subscriptions.length} {data.subscriptions.length === 1 ? 'Participant' : 'Participants'}
              </span>
            </>
          )}
          {(!data?.subscriptions || data.subscriptions.length === 0) && (
            <span className="text-base font-semibold text-warmGray">
              No Participants Yet
            </span>
          )}
            <span>
            <button
              onClick={() => goToParticipantsView(data?.id)}
              className="px-4 py-2 text-xs bg-lightBlueColor text-white  rounded-lg font-semibold"
            >
              View Participants
            </button>
          </span>
        </div>
        <div className=" flex gap-6 mt-8">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`text-xs font-semibold pb-1 transition-colors duration-300 ${activeTab.name === tab.name
                ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                : "text-mediumGrayText hover:text-lightBlueColor"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="mt-4">
          {activeTab.name === "Overview" ? (
            <ExperienceDetail eventData={data} />
          ) : activeTab.name === "Community" ? (
            <AmbassadorCommunity eventId={data?.id} />
          ) : null}
        </div> 
      </div>
    </div>
  );
};

export default AmbassadorExperiencesView;

